import { CreateCompanyProps } from '@commenda/types/src/company/types';
import { fetcher } from '@commenda/utils';

export default async function createCompany({
  data,
  nextAuthToken,
}: {
  data: CreateCompanyProps;
  nextAuthToken: string;
}): Promise<Response> {
  const res = await fetcher(
    `company`,
    {
      method: 'POST',
      body: { ...data },
    },
    nextAuthToken
  );

  return res;
}
